/**
 * Indicate that we want to save cookies choices
 * @type {string}
 */
export const SAVE_COOKIES_CHOICES = "SAVE_COOKIES_CHOICES"
